import hero from "../components/hero";
import main from "../components/main";

export default function loadWeatherApp() {
    hero();
    main();
}